module.exports = __webpack_public_path__ + "img/nftart.681a14f1.svg";